import { render } from "./ManageTicket.vue?vue&type=template&id=3c7e7b86&scoped=true"
import script from "./ManageTicket.vue?vue&type=script&lang=js"
export * from "./ManageTicket.vue?vue&type=script&lang=js"

import "./ManageTicket.vue?vue&type=style&index=0&id=3c7e7b86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7e7b86"]])

export default __exports__